var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-success m-0 alert-small"},[_c('font-awesome-icon',{staticClass:"mr-1",attrs:{"icon":['fas', 'check-circle']}}),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }